import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

// @vue/component
export default {
  name: "NachrichtenModalDelete",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    nachricht: {
      type: Object,
      default: () => ({}),
    },
    baseUrl: {
      type: String,
      default: undefined,
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      modalOptions: {
        showCloseButton: true,
      },
      status: {
        loading: undefined,
      },
    };
  },
  methods: {
    deleteNachricht() {
      this.status.loading = true;
      this.deleteHttp({ url: `${ this.baseUrl }${ this.nachricht.pk }/` }).then(
        () => {
          this.addNotification({ text: "_MSG_NACHRICHTEN_MODAL_DELETE_SUCCESS_" });
          this.close({ status: true });
        },
        () => this.addNotification({ text: "_MSG_NACHRICHTEN_MODAL_DELETE_ERROR_", type: "error" })
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
